<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormSelectComponent 
            :name="'user_id'"
            :listaDeOptions="listaDeUsuarios"
            v-model="formulario.user_id"
            :optionLabel="'name'"
            :placeholder="'Usuário'"
            :error="validationErrors.first('user_id')"
            data-vv-as="Usuário"
            v-validate="'required'"
          />
      </div>
      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'descricao'"
            v-model="formulario.descricao" 
            :placeholder="'Descrição'"
            data-vv-as="Descrição"
            v-validate="'required|max:255'"
            :error="validationErrors.first('descricao')"
         />
      </div>    
      <div class="mb-3" v-if="tipoFormulario !== 'salvar'">
        <SGPFormToggleComponent
          name="alterar_senha"
          titulo="Alterar Senha"
          v-model="alterarSenha"            
                
        />      
      </div>    
      <div class="mb-3" v-if="alterarSenha == 1">
        <SGPFormInputComponent 
            type="text" 
            :name="'password'"
            v-model="formulario.password" 
            :placeholder="'Senha'"
            data-vv-as="Senha"
            v-validate="'required|min:10|max:50'"
            id="password"
            ref="password"
            :error="validationErrors.first('password')"
         />
      </div>
      <div class="mb-3" v-if="alterarSenha == 1">
        <SGPFormInputComponent 
            type="text" 
            :name="'confirm_password'"
            v-model="formulario.confirm_password" 
            :placeholder="'Confirmação de Senha'"
            data-vv-as="Confirmação de Senha"
            v-validate="'required|max:50|confirmed:password'"
            id="confirm_password"

            :error="validationErrors.first('confirm_password')"
         />
      </div>
      
      <div class="container-botoes">
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
     </div>
      
    </form>
    

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "FormularioUsuarioApiComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    usuarioApi: {
      type: Object,
      required: false
    }
  },

  data () {
    let form;
    let podeAlterarSenha = 1;
    if(this.tipoFormulario === 'salvar') {
      form = {
        user_id: '',
        descricao: '',
        password: '',
        confirm_password: ''
      };
    } else {
      form = {
        id: this.$props.usuarioApi.id,
        user_id: this.$props.usuarioApi.user_id,
        descricao: this.$props.usuarioApi.descricao,
        password: '',
        confirm_password: ''
      };

      podeAlterarSenha = 0;
    }

    return {
      formulario: form,
      alterarSenha: podeAlterarSenha
    }
  },

  computed: {
    ...mapGetters('usuarios', ['listaDeUsuarios'])
  },
  methods: {
    ...mapActions('usuariosApis', [
      'salvarUsuarioApi',
      'atualizarUsuarioApi'
    ]),
    ...mapActions('usuarios', [ 'listarUsuarios']),
    
     validate: function () {
          this.$validator.validateAll();
        },
     limparCampos () {
      this.formulario.user_id = '';
      this.formulario.descricao = '';
      this.formulario.password = '';
      this.formulario.confirm_password = '';
      this.$validator.reset();
     },   
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
          // eslint-disable-next-line
          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarUsuarioApi(this.formulario);            
            if(!resp) { 
              return;
            }
          }else{
              const resp = await this.atualizarUsuarioApi(this.formulario);
              if(!resp){
                return;
              } 
          }

          this.limparCampos();
          this.fecharModal();
          return;
        }
      });     
       
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  },beforeMount(){
    this.listarUsuarios();
 }

}
</script>